<div class="page-container home-page">
  <div class="home-hero card">
    <div class="home-hero__content">
      <img class="labtech_logo_home" src="assets/images/Labtech_Logo.jpg" alt="LabTech Logo" />
      <div>
        <h1>Welcome back, {{ auth.displayName }}</h1>
        <p class="home-hero__subtitle">Here are your next upcoming inspections.</p>
      </div>
    </div>

    <div class="home-hero__actions">
      <button class="btn-secondary" type="button" (click)="openInspectionOverview()">
        <span class="material-icons">calendar_month</span>
        Inspection Overview
      </button>
    </div>
  </div>

  <div class="home-section card">
    <div class="home-section__header">
      <div>
        <h2>Upcoming Inspections</h2>
        <p class="home-section__subtitle">The next planned inspections are shown here as tiles.</p>
      </div>
      <span *ngIf="!loading" class="result-count">{{ upcomingInspections.length }} visible</span>
    </div>

    <div *ngIf="loading" class="home-state">
      <span class="material-icons home-state__icon home-state__icon--spin">progress_activity</span>
      <p>Loading inspections...</p>
    </div>

    <div *ngIf="!loading && upcomingInspections.length > 0" class="upcoming-grid">
      <article class="inspection-tile" *ngFor="let inspection of upcomingInspections">
        <div class="inspection-tile__header">
          <div>
            <div class="inspection-tile__eyebrow">Inspection</div>
            <h3>{{ inspection.orderNumber || inspection.reportNumber || 'No order number' }}</h3>
          </div>
          <span class="status-chip" [ngClass]="statusClass(inspection)">
            {{ statusLabel(inspection) }}
          </span>
        </div>

        <div class="inspection-tile__meta">
          <div class="inspection-meta-item">
            <span class="material-icons">event</span>
            <div>
              <span class="inspection-meta-item__label">Inspection Date</span>
              <strong>{{ inspection.inspectionDate | date:'dd.MM.yyyy' }}</strong>
            </div>
          </div>

          <div class="inspection-meta-item">
            <span class="material-icons">category</span>
            <div>
              <span class="inspection-meta-item__label">Inspection Type</span>
              <strong>{{ inspection.inspectionType || 'N/A' }}</strong>
            </div>
          </div>

          <div class="inspection-meta-item">
            <span class="material-icons">person</span>
            <div>
              <span class="inspection-meta-item__label">Customer</span>
              <strong>{{ inspection.customer || 'N/A' }}</strong>
            </div>
          </div>

          <div class="inspection-meta-item">
            <span class="material-icons">factory</span>
            <div>
              <span class="inspection-meta-item__label">Factory</span>
              <strong>{{ inspection.factory || 'N/A' }}</strong>
            </div>
          </div>

          <div class="inspection-meta-item">
            <span class="material-icons">groups</span>
            <div>
              <span class="inspection-meta-item__label">Inspectors</span>
              <strong>{{ inspection.inspectors || 'N/A' }}</strong>
            </div>
          </div>
        </div>

        <div class="inspection-tile__actions">
          <button class="btn-secondary" type="button" (click)="openInspection(inspection)">
            <span class="material-icons">{{ isStarted(inspection) ? 'visibility' : 'edit' }}</span>
            {{ isStarted(inspection) ? 'Open' : 'Edit' }}
          </button>
          <button class="btn-primary" type="button" (click)="executeInspection(inspection)">
            <span class="material-icons">play_arrow</span>
            Execute
          </button>
        </div>
      </article>
    </div>

    <app-empty-state
      *ngIf="!loading && upcomingInspections.length === 0"
      icon="event_busy"
      headline="No upcoming inspections"
      subline="There are currently no planned inspections with an upcoming date.">
    </app-empty-state>
  </div>
</div>
